const mediaPaths = {
    batchFileSpec: `${process.env.PUBLIC_URL}/media/documents/BPOINT_Batch_File_Specification_2.0_20190701.pdf`,
};

export default mediaPaths;